import { rest } from "msw";
import type { RestHandler } from "msw";
import config from "../../config";
import { apiVersion, features } from "../../shared/constants/common.constant";

export const mockEnableAuthorizationFeatureFlag = (): RestHandler => {
  const url = `${config.COMPLIANCE_API_URL}/${apiVersion}/Features/${features.enableAuthorization}`;
  return rest.get(url, (_req, res, ctx) =>
    res(ctx.status(200), ctx.json([{ enabled: true }]))
  );
};
